module.exports = __webpack_public_path__ + "img/black_hover.b6ea6d6a.png";